<section>
    <div class="numbers">
        <div class="number">
            <span class="value">1 mln<span class="plus">+</span></span>
            <p>mieszkań zarządzanych w systemie</p>
        </div>
        <div class="number">
            <span class="value">25%</span>
            <p>spółdzielni mieszkaniowych w Polsce</p>
        </div>
        <div class="number">
            <span class="value">5000<span class="plus">+</span></span>
            <p>wspólnot mieszkaniowych</p>
        </div>
    </div>
</section>
